

interface ComingSoonProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  position?: 'top-right' | 'top-left' | 'center';
}

export default function ComingSoon({ 
  className = '', 
  size = 'md',
  position = 'top-right' 
}: ComingSoonProps) {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-xs',
    lg: 'px-4 py-2 text-sm'
  };

  const positionClasses = {
    'top-right': 'absolute top-4 right-4 z-10',
    'top-left': 'absolute top-4 left-4 z-10',
    'center': 'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10'
  };

  return (
    <div className={`
      ${positionClasses[position]}
      bg-blue-600 text-white 
      ${sizeClasses[size]} 
      rounded-full font-medium shadow-lg
      ${className}
    `}>
      Coming Soon
    </div>
  );
}